import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  Inject
} from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';

/**
 * Angular implementation of the bringoz-datetime-range component.
 * This component provides a date picker and time selectors for selecting a date and time range.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-bringoz-datetime-range',
  templateUrl: './bringoz-datetime-range.html'
})
export class BringozDatetimeRangeComponent implements OnInit, OnChanges {
  @Input() from: number;
  @Input() to: number;
  @Input() min: number;
  @Input() max: number;
  @Input() timeOnly: boolean;
  @Input() isRequired: boolean;
  @Input() isDisabled: boolean;
  @Input() isRow: string;

  @Output() onRangeChange = new EventEmitter<{ from: number, to: number }>();

  timeConfig: {
    from: {
      date: Date;
      value: number;
    };
    to: {
      date: Date;
      value: number;
    };
  };

  minDate: Date;
  maxDate: Date;

  constructor() {}

  ngOnInit(): void {
    if (!this.from && !this.to) {
      this.from = moment().startOf('day').valueOf();
      this.to = moment().endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
    }

    if (this.min) {
      this.minDate = new Date(this.min);
    }

    if (this.max) {
      this.maxDate = new Date(this.max);
    }

    this.setConfig(this.from, this.to);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.from && !changes.from.isFirstChange()) ||
        (changes.to && !changes.to.isFirstChange())) {
      this.setConfig(this.from, this.to);
    }
  }

  onFromDateChange(from: number): void {
    const fromDateMoment = moment(from);
    const day = fromDateMoment.date();
    const month = fromDateMoment.month();
    const year = fromDateMoment.year();

    this.timeConfig.from.value = moment(this.timeConfig.from.value)
      .set({
        'year': year,
        'month': month,
        'date': day
      })
      .valueOf();

    if (!moment(this.timeConfig.from.date).isSame(moment(this.timeConfig.to.date), 'date')) {
      this.timeConfig.to.date = moment(from).toDate();
      this.timeConfig.to.value = moment(from)
        .endOf('day')
        .set({
          'minute': 45,
          'second': 0,
          'millisecond': 0
        })
        .valueOf();
    }

    this.onRangeChange.emit({from: this.timeConfig.from.value, to: this.timeConfig.to.value});
  }

  onFromTimeChange(time: number): void {
    this.timeConfig.from.value = time;
    this.onRangeChange.emit({from: this.timeConfig.from.value, to: this.timeConfig.to.value});
  }

  onToTimeChange(time: number): void {
    this.timeConfig.to.value = time;
    this.onRangeChange.emit({from: this.timeConfig.from.value, to: this.timeConfig.to.value});
  }

  private setConfig(from: number, to: number): void {
    this.timeConfig = {
      from: {
        date: from ? moment(from).toDate() : undefined,
        value: from ? moment(from).valueOf() : undefined
      },
      to: {
        date: to ? moment(to).toDate() : undefined,
        value: to ? moment(to).valueOf() : undefined
      }
    };
  }
}
